/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryRepoType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryRepoType");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryRepoType.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryRepoType>): AutomationTemplateQueryRepoType {
        let obj = Object.assign(new AutomationTemplateQueryRepoType(), model);
        AutomationTemplateQueryRepoType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryRepoType>): AutomationTemplateQueryRepoType {
        if (!model) return null;
        return AutomationTemplateQueryRepoType.newInstance(<AutomationTemplateQueryRepoType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryRepoType) {
        if (!obj) return;

        models.AutomationTemplateQueryRepoType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryRepoType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryRepoType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Repo type of the template
     */
    repo_types: Array<string>;

}
